import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { ExclusiveCollectionBadge } from 'Components/widgets/exclusive-collection-badge/ExclusiveCollectionBadge';
import {
  getAccommodationTitle,
  getDiscountValueFromProposal,
  getExclusiveCollectionInAccommodations,
} from './ProposalAccommodationTitleUtils';
import { themes } from './ProposalAccommodationTitle.themes';
import { PromotionTag } from './PromotionTag';
type Props = {
  includedLabel?: string;
  priceLabel: string | null | undefined;
  product: Product;
  proposal: Proposal;
  uniqDiscounts: Array<number>;
  style?: {};
  theme?: 'default' | 'column';
};
export const ProposalAccommodationTitle = ({
  includedLabel,
  priceLabel,
  product,
  proposal,
  uniqDiscounts,
  theme = 'default',
}: Props) => {
  const appContext = useAppContext();
  const isExclusiveCollection = getExclusiveCollectionInAccommodations(proposal, product);
  const { thLabel, thRoot, thTitle } = themes(isExclusiveCollection)[theme];
  const discountValue = getDiscountValueFromProposal(proposal);
  const proposalHasHappyFirstOffer = !!discountValue;
  const hasNoShownHappyFirst =
    !proposalHasHappyFirstOffer || !isFeatureFlipped(appContext)('booking.promotionHappyFirst');
  return (
    <span className={thRoot} data-testid="ProposalAccommodationTitle">
      <span className={thTitle}>{getAccommodationTitle(proposal, product)}</span>
      {hasNoShownHappyFirst && (
        <span className={thLabel} data-testid="price-accommodationsTabs">
          {priceLabel}
          {includedLabel}
        </span>
      )}
      {isExclusiveCollection && <ExclusiveCollectionBadge />}
      <PromotionTag proposal={proposal} uniqDiscounts={uniqDiscounts} />
    </span>
  );
};
